import { createContext, PropsWithChildren, useContext } from 'react';
import {
  DeviceSelectionPreference,
  useDeviceSelectionPreference,
} from '../hooks/useDeviceSelectionPreference';

const defaultState: Settings = {
  deviceSelectionPreference: 'recent',
  setDeviceSelectionPreference: () => {},
};

export type Settings = {
  deviceSelectionPreference: DeviceSelectionPreference;
  setDeviceSelectionPreference: (value: DeviceSelectionPreference) => void;
};

export type SettingsContextValue = {
  settings: Settings;
};

const SettingsContext = createContext<SettingsContextValue>({
  settings: defaultState,
});

export const SettingsProvider = ({ children }: PropsWithChildren) => {
  const { deviceSelectionPreference, setDeviceSelectionPreference } =
    useDeviceSelectionPreference();

  const settings: Settings = {
    deviceSelectionPreference,
    setDeviceSelectionPreference,
  };

  return (
    <SettingsContext.Provider
      value={{
        settings,
      }}
    >
      {children}
    </SettingsContext.Provider>
  );
};

export const useSettings = () => useContext(SettingsContext);
